<template>
  <div class="no-navbar-layout" :class="{ desktop: $isDesktop }">
    <nav class="nav-bar">
      <pu-homepage-link>
        <img
          src="@/assets/images/pitchup-favicon.svg"
          alt=""
          width="41"
          height="36"
        />
        <span class="menu-chevron"
          ><span class="chevron-l" /><span class="chevron-r"
        /></span>
        <span class="sr-only">Menu</span>
      </pu-homepage-link>
    </nav>
    <slot class="nuxt-content" />

    <footer :class="{ desktop: $isDesktop }">
      <version />
      <copyright />
    </footer>
  </div>
</template>

<style scoped>
.no-navbar-layout {
  min-height: 100dvh;
}

.nav-bar {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  padding: 0.8em 1.5em;
  margin: 0 auto;
}

.nav-bar img {
  width: auto;
  height: 2em;
}

footer {
  padding: 1.4em 1em 0.25em;
  display: flex;
  justify-content: space-between;
  gap: 1em;
}

footer p {
  padding: 0 !important;
}

/* desktop & tablet */
footer.desktop {
  padding: 1.4em 2em 0.75em;
}
</style>
